/* eslint-disable no-console */
import './app/utils/extensions'; // carrega os prototypes extendidos

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import {
	init,
	browserTracingIntegration,
	replayIntegration,
} from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

init({
	dsn: environment.sentry.dsn,
	environment: environment.name,
	integrations: [
		// Registers and configures the Tracing integration,
		// which automatically instruments your application to monitor its
		// performance, including custom Angular routing instrumentation
		browserTracingIntegration(),
		// Registers the Replay integration,
		// which automatically captures Session Replays
		replayIntegration(),
	],
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate,
	// plus for 100% of sessions with an error
	replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
	// Capture Replay for 10% of all sessions,
	// Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
	tracePropagationTargets: ['localhost', environment.apiUrl],
	// We recommend adjusting this value in production
	tracesSampleRate: environment.sentry.tracesSampleRate,
});

if (environment.isProduction) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
